import { MediaObject } from 'types'

const ACCEPTABLE_RATIOS: ReadonlyArray<number> = [0.8, 1, 1.91]
const DEFAULT_RATIO = ACCEPTABLE_RATIOS[0]

export const calculateAspectRatio = (mediaObject: MediaObject): number => {
  if (!mediaObject.width || !mediaObject.height) {
    return DEFAULT_RATIO
  }

  const actualRatio = mediaObject.width / mediaObject.height

  let closestRatio = DEFAULT_RATIO
  let smallestDifference = Math.abs(actualRatio - closestRatio)

  for (const acceptableRatio of ACCEPTABLE_RATIOS) {
    const difference = Math.abs(actualRatio - acceptableRatio)
    if (difference < smallestDifference) {
      smallestDifference = difference
      closestRatio = acceptableRatio
    }
  }

  return closestRatio
}
